import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class IntramirrorCategoryMapApiClient extends AdvancedApiClient {

    static entityType = "IntramirrorCategoryMap"

    constructor(token, categoryId, id) {
        super();

        this.setEntityType(IntramirrorCategoryMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/category/{cid}/intramirror-map/{id}")
                .setRouteParam("cid", categoryId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/category/{cid}/intramirror-map")
                .setRouteParam("cid", categoryId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}